// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"855":"94c66249","908":"1e34237b"}[chunkId] + ".chunk.js";
};